import Text from '../../general/Typography/Text/Text'
import { Tag as AntdTag, TagProps } from 'antd'

/**
 *
 * this is Antd Tag component with Text component inside
 * for more documentation check Antd docs
 *
 */
const Tag = (props: TagProps) => {
  const { children, ...restProps } = props

  return (
    <AntdTag {...restProps}>
      <Text level={2}>{children}</Text>
    </AntdTag>
  )
}

export default Tag
